import { useRef } from "react";
import { useAnimationFrame } from "framer-motion";

// Horizontal gallery: gentle auto-scroll, but fully scrollable/draggable and clickable.
export const GalleryStrip = ({ items, onSelect }) => {
  const ref = useRef(null);
  const paused = useRef(false);
  const drag = useRef({ active: false, startX: 0, startLeft: 0, moved: false });
  const loop = [...items, ...items];

  useAnimationFrame(() => {
    const el = ref.current;
    if (!el || paused.current || drag.current.active) return;
    el.scrollLeft += 0.5;
    const half = el.scrollWidth / 2;
    if (el.scrollLeft >= half) el.scrollLeft -= half;
  });

  const onPointerDown = (e) => {
    const el = ref.current;
    drag.current = { active: true, startX: e.clientX, startLeft: el.scrollLeft, moved: false };
    el.classList.add("dragging");
  };
  const onPointerMove = (e) => {
    if (!drag.current.active) return;
    const dx = e.clientX - drag.current.startX;
    if (Math.abs(dx) > 4) drag.current.moved = true;
    ref.current.scrollLeft = drag.current.startLeft - dx;
  };
  const endDrag = () => {
    drag.current.active = false;
    if (ref.current) ref.current.classList.remove("dragging");
  };

  return (
    <div
      ref={ref}
      className="gallery-scroll"
      data-testid="gallery-strip"
      onMouseEnter={() => (paused.current = true)}
      onMouseLeave={() => {
        paused.current = false;
        endDrag();
      }}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={endDrag}
      onPointerCancel={endDrag}
    >
      {loop.map((g, i) => {
        const realIndex = i % items.length;
        const first = i < items.length;
        return (
          <button
            key={i}
            className="gallery-card group"
            aria-label={g.alt}
            data-testid={first ? `gallery-item-${realIndex}` : undefined}
            onClick={() => {
              if (drag.current.moved) return;
              onSelect(realIndex);
            }}
          >
            <img src={g.src} alt={g.alt} loading="eager" decoding="async" draggable="false" />
          </button>
        );
      })}
    </div>
  );
};
